import { RadioButtonCheckedOutlined } from '@material-ui/icons';
import React, { useCallback, useState } from 'react';

import '../../css/utils/flex.css';
import AnchorStats from './AnchorStats';
import BioVideo from './BioVideo';
import SocialMediaLinks from './SocialMediaLinks';


function Bio(props) {
  const {
    anchor,
    user,
    isImageLayout,
    authenticated,
    promoVideo,
    promoThumbnail,
    totalVideosCount,
    totalGalleriesCount,
  } = props;
  const [readMore, setReadMore] = useState(false);
  const isNakedNewsLive = anchor.id === 241;

  const toggleReadMore = useCallback(() => {
    setReadMore(!readMore);
  }, [readMore, setReadMore]);

  const GalleriesCount = useCallback(() => {
    const shouldRenderGalleriesCount = !isNakedNewsLive && (totalVideosCount !== 0 || totalGalleriesCount !== 0);
    if (!shouldRenderGalleriesCount) {
      return null;
    }

    return (
      <div className="videos-galleries-count">
        <ul>
          <li>
            <RadioButtonCheckedOutlined />&nbsp;
            <span>
              {totalVideosCount}&nbsp;Videos
            </span>
          </li>
          <li>
            <RadioButtonCheckedOutlined />&nbsp;
            <span>
              {totalGalleriesCount}&nbsp;Galleries
            </span>
          </li>
        </ul>
      </div>
    );
  }, [isNakedNewsLive, totalGalleriesCount, totalVideosCount]);

  const ReadMoreButton = useCallback(() => {
    const text = readMore ? 'less' : 'more...';
    if (isNakedNewsLive) {
      return null;
    }

    return (
      <button
        className="read-more-toggler text-left"
        onClick={toggleReadMore}
      >
        Read {text}
      </button>
    );
  }, [isNakedNewsLive, readMore, toggleReadMore]);

  const SubscriptionPurchaseLink = useCallback(() => {
    const shouldShowLink = !authenticated && !isNakedNewsLive;
    if (!shouldShowLink) {
      return null;
    }

    return (
      <a
        className="strip-show-link"
        href="/account/purchase"
      >
        Watch {anchor.name}'s Full Strip Show
        inside Naked News
      </a>
    );
  }, [anchor.name, authenticated, isNakedNewsLive]);

  const anchorHasSocialLinks = useCallback(() =>
    (anchor.facebook !== '' ||
        anchor.twitter !== '' ||
            anchor.snapchat !== '' ||
                anchor.instagram !== '' ||
                    anchor.tiktok !== ''), [anchor]);

  const liveBioContainer = isNakedNewsLive ? 'live-bio-container' : '';
  const containerClass = `container ${liveBioContainer}`;
  const imageLayoutClass = isImageLayout ? 'anchor-pedigree image-layout' : 'anchor-pedigree';
  const videoPlayerClass = `${!isNakedNewsLive ? 'bio-container-video-player' : ''}`;
  const bioRightSectionClass = `${liveBioContainer}-main col-sm-12 col-xs-12`;
  const hasSocialLinks = anchorHasSocialLinks(anchor);
  const readMoreClass = !isNakedNewsLive && (readMore ? 'unclipped' : 'clipped');

  return (
    <div className="masthead anchor-pedigree-container">
      <div className={containerClass}>
        <div className={imageLayoutClass}>
          <div className="row">
            <AnchorStats
              anchor={anchor}
              isImageLayout={isImageLayout}
              isNakedNewsLive={isNakedNewsLive}
            />
            <div className={videoPlayerClass}>
              <div className="bio-column-left">
                <GalleriesCount />
                <div className={bioRightSectionClass}>
                  <div className="anchor-pedigree-main">
                    <div className="anchor-pedigree-bio">
                      <div className={`biography-text ${readMoreClass}`}>
                        <p>
                          <strong>Bio: </strong>
                          <span
                            dangerouslySetInnerHTML={{ __html: anchor.biography.bio }}
                            style={{ display: 'block' }}
                          />
                        </p>
                      </div>
                      <ReadMoreButton />
                      <SubscriptionPurchaseLink />
                      <SocialMediaLinks
                        anchor={anchor}
                        hasSocialLinks={hasSocialLinks}
                        isNakedNewsLive={isNakedNewsLive}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <BioVideo
                anchor={anchor}
                promoThumbnail={promoThumbnail}
                promoVideo={promoVideo}
                user={user}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Bio;

